'use client'

import Script from 'next/script'
import { Suspense } from 'react'

interface IProps {
  datacid: string
  datakey: string
}

const CookiesCheck = ({ datacid, datakey }: IProps) => (
  <Suspense>
    <div id="infotext" data-lenis-prevent />
    <div
      id="kekschecker"
      data-cid={datacid}
      data-key={datakey}
      className="hidden"
      style={{ display: 'none' }}
    />
    <Script
      src="https://legal.spotwerbung.ch/datenschutz/v2/kekschecker.js"
      strategy="afterInteractive"
      async
      defer
    />
  </Suspense>
)

export default CookiesCheck
